(function ($) {
    // use this transport for "binary" data type
    $.ajaxTransport('+binary', function (options, originalOptions, jqXHR) {
        // check for conditions and support for blob / arraybuffer response type
        if (window.FormData && ((options.dataType && (options.dataType === 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
            return {
                // create new XMLHttpRequest
                send: function (headers, callback) {
                    // setup all variables
                    const xhr = new XMLHttpRequest();
                    const url = options.url;
                    const type = options.type;
                    const async = options.async || true;
                    const dataType = options.responseType || 'blob';
                    const data = options.data || null;
                    const username = options.username || null;
                    const password = options.password || null;

                    xhr.addEventListener('load', function () {
                        const req = {};
                        req[options.dataType] = xhr.response;
                        // make callback and send data
                        callback(xhr.status, xhr.statusText, req, xhr.getAllResponseHeaders());
                    });

                    xhr.open(type, url, async, username, password);

                    // setup custom headers
                    for (let i in headers) {
                        xhr.setRequestHeader(i, headers[i]);
                    }

                    xhr.responseType = dataType;
                    xhr.send(data);
                },
                abort: function () {
                }
            };
        }
    });
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/scripts/api/binary.js